
import { Component, Input } from '@angular/core';
import { CatalogSearchResultDisplayType } from '@enums/catalog-search-result-display-type';
import { CatalogViewForeignLanguageCatalogsDto, CatalogViewRelatedCatalogsDto } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { ICatalogQueryParams, ICatalogRoutingParams } from '@interfaces/iCatalogRoutingParams';
import { CatalogSearchresultModel } from '@services/search-result.service';
import { AdditionalCatalogsComponent } from "../additional-catalogs/additional-catalogs.component";
import { ForeignLanguageCatalogsComponent } from "../foreign-language-catalogs/foreign-language-catalogs.component";

@Component({
    selector: 'app-more-catalogs',
    templateUrl: './more-catalogs.component.html',
    styleUrls: ['./more-catalogs.component.scss'],
    imports: [ForeignLanguageCatalogsComponent, AdditionalCatalogsComponent]
})
export class MoreCatalogsComponent {
	@Input() currentQueryParams: ICatalogQueryParams;
	@Input() currentRoutingParams: ICatalogRoutingParams;
	@Input() isPreview = false;
	@Input() relatedCatalogs: CatalogViewRelatedCatalogsDto[];
	@Input() catalogSearchResultModel: CatalogSearchresultModel = { catalogFilterEntries: [], displayType: CatalogSearchResultDisplayType.Catalog, isEmptySearch: false, searchTags: [] };
	@Input() languageCatalogs: CatalogViewForeignLanguageCatalogsDto[];
	@Input() showAdditionalCatalogs: boolean;
	@Input() showForeignLanguageCatalogs: boolean;
}
